// Product page: update the price when a size is chosen.
const price = document.querySelector('[data-ogni-price]');
if (price) {
  document.addEventListener('change', (event) => {
    const input = event.target.closest('input[name="id"][data-price]');
    if (input) price.textContent = input.dataset.price;
  });
}
